import React, { lazy } from "react";
import PrivateRoute from "PrivateRoutes";
import queryString from "query-string";
// import { UserEdit  } from "./components";
const User = lazy(() => import(/* webpackChunkName: "User" */"./components"));
const UserEdit = lazy(() => import(/* webpackChunkName: "User" */"./components/UserEdit"));
const SkillsManage = lazy(() => import(/* webpackChunkName: "SkillsManage" */"./components/SkillsManage"));
// const SkillsManage = lazy(() => import(/* webpackChunkName: "SkillsManage" */"./components/indexSkillManage"));

// const routes = () => (
//   <PrivateRoute exact path="/settings/User" component={User} />
// );

const editForm = ({ match }) => {
  return <SkillsManage mode="edit" userId={match.params._id} />;
};

const editDataForm = ({ match }) => {
  return <UserEdit mode="edit" userEditId={match.params._id} />;
};

const routes = () => {
  return (
    <React.Fragment>
      <PrivateRoute
        key="/settings/User"
        exact={true}
        path="/settings/User"
        component={User}
      />

      {/* <PrivateRoute
        key="/settings/User/Manage"
        exact={true}
        path="/settings/User/Manage/:_id"
        component={editDataForm}
      /> */}

      <PrivateRoute
        key="/settings/User/SkillsManage"
        exact={true}
        path="/settings/User/SkillsManage/:_id"
        component={editForm}
      />
    </React.Fragment>
  );
};

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/User/routes.js